import {changeClaimChecks, ClaimActionType, getClaimChecksPost} from 'Agent/Claims/ducks/claim';
import {Check} from 'Agent/Claims/models/Check';
import {Claim} from 'Agent/Claims/models/Claim';
import {AsyncResult, fromResult, Loading, ServerError} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {flow} from 'fp-ts/lib/function';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {eq} from 'Shared/utilities/equals';
import {post} from 'Shared/utilities/fetchHelpers';
import {removeApiPrefix} from 'Shared/utilities/PageUtility';
import {prop} from 'Shared/utilities/prop';
import {DataSource,getEisFlagFromLinks} from 'Shared/utilities/DataSourceUtility';

const getCheckUri = (encryptedIdentifier: string) =>
  flow(
    prop<Claim, 'links'>('links'),
    O.fromNullable,
    O.chain(NEA.fromArray),
    O.chain(NEA.filter(eq('rel', 'details'))),
    O.map(NEA.head),
    O.map(prop('href')),
    O.chain(O.fromNullable),
    O.map(removeApiPrefix),
    O.map(uri => `/api/claims/v1/checks?${addFilterParameters({encryptedIdentifier}).slice(1)}`),
  );

function* getChecksSaga() {
  yield takeLatest(ClaimActionType.GET_CLAIM_CHECKS, function*(action: ReturnType<typeof getClaimChecksPost>) {
    const {claim, encryptedIdentifier} = action.payload;
    const eisFlag = Number(getEisFlagFromLinks(claim.links)) === DataSource.EIS
    const checksFormData = new FormData();
    checksFormData.append('policynumber', claim.policyNumber ?? "");
    checksFormData.append('encryptedclaimnumber', claim.encrytpedClaimNumber ?? "");
    checksFormData.append('eisFlag', eisFlag.toString());

    yield put(changeClaimChecks(new Loading()));

    yield pipe(
      getCheckUri(encryptedIdentifier)(claim),
      O.fold(
        () => put(changeClaimChecks(new ServerError('Unable to Retrieve Checks'))),
        function* loadCheck(checkUri: string): unknown {
          const checks: AsyncResult<Check[]> = yield call(post, checkUri,checksFormData);

          if (E.isRight(checks)) {
            yield put(changeClaimChecks(fromResult(checks.right)));
          } else {
            yield put(changeClaimChecks(new ServerError('Unable to Retrieve Checks')));
          }
        }
      )
    );
  });
}

export default function*() {
  yield all([getChecksSaga()]);
}
